import SideSheetModal from "@/components/SideSheetModal";
import { ColumnSort } from "@tanstack/react-table";
import Icon from "@/components/Icon";
import Button from "@/components/Button";

interface SortOption {
  id: string;
  label: string;
  desc: boolean;
  display: string;
}

interface MobileSortDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSortChange: (sort: ColumnSort[]) => void;
  currentSort: ColumnSort[];
}

const sortOptions: SortOption[] = [
  { id: "pgaId", label: "PGA ID", desc: false, display: "Low to High" },
  { id: "pgaId", label: "PGA ID", desc: true, display: "High to Low" },
  { id: "classification", label: "Classification", desc: false, display: "A to Z" },
  { id: "classification", label: "Classification", desc: true, display: "Z to A" },
  { id: "section", label: "Section", desc: false, display: "A to Z" },
  { id: "section", label: "Section", desc: true, display: "Z to A" },
  { id: "balance", label: "Balance", desc: true, display: "High to Low" },
  { id: "balance", label: "Balance", desc: false, display: "Low to High" },
  { id: "dueDate", label: "Due Date", desc: true, display: "Latest to Earliest" },
  { id: "dueDate", label: "Due Date", desc: false, display: "Earliest to Latest" },
  { id: "updatedAt", label: "Modified", desc: true, display: "New to Old" },
  { id: "updatedAt", label: "Modified", desc: false, display: "Old to New" },
  { id: "products", label: "Products", desc: true, display: "Most to Least" },
  { id: "products", label: "Products", desc: false, display: "Least to Most" }
];

export default function MobileSortDrawer({ isOpen, onClose, onSortChange, currentSort }: MobileSortDrawerProps) {
  const handleSortSelect = (option: SortOption) => {
    onSortChange([{ id: option.id, desc: option.desc }]);
    onClose();
  };

  const isCurrentSort = (option: SortOption) => {
    return currentSort.length > 0 && currentSort[0].id === option.id && currentSort[0].desc === option.desc;
  };

  const handleSidebarChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <SideSheetModal
      isSidebarOpen={isOpen}
      setSidebarOpen={handleSidebarChange}
      title="Sort Table By"
      disableFocusManagement={true}
      actions={
        <Button variant="filled" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="space-y-0 mt-4">
        {sortOptions.map((option) => (
          <button
            key={`${option.id}-${option.desc}`}
            onClick={() => handleSortSelect(option)}
            className="w-full flex items-center justify-between py-4 text-left hover:bg-sys-brand-surface-container transition-colors border-b border-sys-brand-surface-container-high last:border-b-0"
          >
            <div className="flex flex-col">
              <span className="text-base font-medium text-sys-brand-on-surface">{option.label}</span>
              <span className="text-sm text-gray-500">{option.display}</span>
            </div>
            {isCurrentSort(option) && <Icon name="check" className="text-blue-600 ml-3" />}
          </button>
        ))}
      </div>
    </SideSheetModal>
  );
}
